<div class="quiz-wrap answered correct">

    <!-- intro -->
    <intro-quiz
        [slide]="intro">
    </intro-quiz>

    <!-- question -->
    <question
        [slide]="slide"
        [index]="i"
        [length]="questions.length"
        *ngFor="let slide of questions; let i = index; trackBy: utils.trackByIndex">
    </question>

</div>

<div class="quiz-wrap answered correct reveal end">

    <!-- results -->
    <results
        [length]="questions.length"
        [slide]="outro">
    </results>

</div>